import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom-v5-compat';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { supplierGridProperties } from '../../data/suppliers-properties';
import { SuppliersBaseRoute } from '../../suppliers-routes';
import { messages } from '../messages';

import type { SupplierData } from '../../types/supplier-types';

const name = <FormattedMessage {...messages.supplierNameColumnHeader} />;

const SupplierNameColumn = ({ data }: { data: SupplierData }) => {
  const navigate = useNavigate();

  const onClick = useCallback(() => {
    navigate(`${SuppliersBaseRoute}/${data.supplierId}`);
  }, [navigate, data.supplierId]);

  return (
    <Button onClick={onClick} theme={THEME_CONSTANTS.link}>
      {data.supplierName}
    </Button>
  );
};

/**
 * Supplier Name column configuration
 * Displays the name of the supplier for suppliers
 */
export const createSupplierNameColumn = () => ({
  name,
  render: (data: SupplierData) => <SupplierNameColumn data={data} />,
  id: supplierGridProperties.supplierName,
});
